import { computed, input, linkedSignal, output } from '@angular/core';
import { Marked } from 'marked';
import { INCOMPLETE_MARKDOWN_LINK_REGEX, MARKDOWN_RENDERER_OPTIONS } from 'AIChatApp/constants/ai-chat.constant';
import * as i0 from "@angular/core";
function AgentStepsComponent_Conditional_0_For_7_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵdomProperty("href", step_r3.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(step_r3.title);
} }
function AgentStepsComponent_Conditional_0_For_7_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const step_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", step_r3.title, " ");
} }
function AgentStepsComponent_Conditional_0_For_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "li", 6)(1, "div", 7);
    i0.ɵɵconditionalCreate(2, AgentStepsComponent_Conditional_0_For_7_Conditional_2_Template, 2, 2, "a", 8)(3, AgentStepsComponent_Conditional_0_For_7_Conditional_3_Template, 1, 1);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElement(4, "div", 9);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const step_r3 = ctx.$implicit;
    const ɵ$index_13_r4 = ctx.$index;
    const ɵ$count_13_r5 = ctx.$count;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("complete", !ctx_r1.streaming() || !(ɵ$index_13_r4 === ɵ$count_13_r5 - 1));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(step_r3.url ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵdomProperty("innerHTML", step_r3.descriptionHtml, i0.ɵɵsanitizeHtml);
} }
function AgentStepsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "button", 0);
    i0.ɵɵdomListener("click", function AgentStepsComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleSteps()); });
    i0.ɵɵdomElementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElement(3, "div", 2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(4, "div", 3)(5, "ul", 4);
    i0.ɵɵrepeaterCreate(6, AgentStepsComponent_Conditional_0_For_7_Template, 5, 4, "li", 5, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵdomElementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.showSteps() ? "Hide Details" : "See Details");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("collapse", !ctx_r1.showSteps())("show", ctx_r1.showSteps())("mb-2", ctx_r1.showSteps());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.renderedSteps());
} }
const marked = new Marked({ renderer: { ...MARKDOWN_RENDERER_OPTIONS } });
export class AgentStepsComponent {
    constructor() {
        this.steps = input.required(...(ngDevMode ? [{ debugName: "steps" }] : []));
        this.streaming = input(false, ...(ngDevMode ? [{ debugName: "streaming" }] : []));
        this.expanded = input(true, ...(ngDevMode ? [{ debugName: "expanded" }] : []));
        this.toggled = output();
        this.showSteps = linkedSignal(() => this.expanded(), ...(ngDevMode ? [{ debugName: "showSteps" }] : []));
        // Thinking blocks can contain markdown, so render their description as HTML the same way
        // assistant text blocks do (see AgentResponseMessageComponent). tool_call steps carry no
        // description, so this only affects "Thought" steps.
        this.renderedSteps = computed(() => this.steps().map((step) => ({
            ...step,
            descriptionHtml: step.description
                ? marked.parse(step.description.replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*'))
                : '',
        })), ...(ngDevMode ? [{ debugName: "renderedSteps" }] : []));
    }
    toggleSteps() {
        const next = !this.showSteps();
        this.showSteps.set(next);
        this.toggled.emit(next);
    }
}
AgentStepsComponent.ɵfac = function AgentStepsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentStepsComponent)(); };
AgentStepsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentStepsComponent, selectors: [["ycn-agent-steps"]], inputs: { steps: [1, "steps"], streaming: [1, "streaming"], expanded: [1, "expanded"] }, outputs: { toggled: "toggled" }, decls: 1, vars: 1, consts: [["role", "button", "aria-controls", "agentStepsDetails", 1, "btn", "btn-transparent-rounded", "mt-2", "mb-2", 3, "click"], [1, "text-thin"], [1, "collapse-chevron", "align-self-center"], ["id", "agentStepsDetails"], [1, "list-steps"], [1, "list-steps-item", 3, "complete"], [1, "list-steps-item"], [1, "list-steps-title"], ["target", "_blank", 1, "text-underline", "text-blue", 3, "href"], [1, "list-steps-description", 3, "innerHTML"]], template: function AgentStepsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, AgentStepsComponent_Conditional_0_Template, 8, 8);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.steps().length > 0 ? 0 : -1);
    } }, encapsulation: 2, changeDetection: 0 });
